import React, { useEffect, useState } from 'react'
import IdleTimer from 'react-idle-timer';
import {
  Layout
} from 'antd';
const { Content } = Layout;
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { connect } from "react-redux";
import RequireAuth from './RequiredAuth'

/**/
import MainHeader from "../../app/layouts/home/components/Header";
import LeftSide from "../../app/layouts/home/components/LeftSide";
import RightSide from "../../app/layouts/home/components/RightSide";

/**/
import HomePage from 'pages/Home/components/Home/home.component'
import LoginPage from 'pages/Login'
import TransferPage from 'pages/Transfer'
import BusinessCards from 'pages/BusinessCards'
import Salary from 'pages/Salary'
import Transfers from 'pages/Transfers'
import Settings from 'pages/Settings'
import Credits from 'pages/Credits'
import Deposits from 'pages/Deposits'
import MassTransfers from 'pages/MassTransfers'
import { leftMenuToggle } from 'store/actions/home'
import ScrollToTop from './ScrollToTop';
import {
  AccountIco, AcquiringIco,
  BusinessCardIco, CreditIco, DepositsIco,
  HomePageIco,
  NewTransferIco,
  SalaryIco,
  TransfersIco
} from "../../modules/CustomIcons";
import Accounts from "pages/AccountsPage/index";
import TemplatesPage from "pages/Templates";
import { useIdleTimer } from 'react-idle-timer'
import i18next from '../../i18n';
import useResponsiveWidth from 'hooks/useResponsiveWidth';
import {useTranslation} from "react-i18next";
import Orders from 'pages/Orders/Main';
import SalaryCardOrder from 'pages/Orders/SalaryCardOrder';
import CreateSalaryCardOrder from 'pages/Orders/SalaryCardOrder/CreateCardOrder';
import UpdateSalaryCardOrder from 'pages/Orders/SalaryCardOrder/UpdateSalaryCardOrder';
import Acquiring from 'pages/Acquiring/Main';
import PostReport from 'pages/Acquiring/PosReport';
import { AppRoute } from './AppRoute';
import businessCardOrder from 'pages/Orders/businessCardOrder';
import CreateBusinessCardOrder from 'pages/Orders/businessCardOrder/CreateBusinessCardOrder';
import UpdateBusinessCardOrder from 'pages/Orders/businessCardOrder/UpdateBusinessCardOrder';

export const routes = [
  {
    component: RequireAuth(HomePage),
    exact: true,
    path: '/',
  },
  {
    component: LoginPage,
    exact: true,
    path: ['/login', '/login/:lang'],
  },
  {
    component: RequireAuth(TransferPage),
    exact: true,
    path: ['/new_transfer', '/new_transfer/:slug1', '/new_transfer/:slug1/:slug2'],
  },
  {
    component: RequireAuth(Accounts),
    exact: true,
    path: ['/accounts', '/accounts/:slug1'],
  },
  {
    component: RequireAuth(BusinessCards),
    exact: true,
    path: ['/business_cards', '/business_cards/:slug1', '/business_cards/:slug1/:slug2'],
    casl: 'BusinessCards',
  },
  {
    component: RequireAuth(Salary),
    exact: true,
    path: ['/salary', '/salary/:slug1', '/salary/:slug1/:slug2'],
  },
  {
    component: RequireAuth(Transfers),
    exact: true,
    path: '/transfers/:id',
  },
  {
    component: RequireAuth(TemplatesPage),
    exact: true,
    path: '/new_transfer/templates',
  },
  {
    component: RequireAuth(MassTransfers),
    exact: true,
    path: '/new_transfer/mass_transfers',
  },
  {
    component: RequireAuth(Credits),
    exact: true,
    path: '/credits',
  },
  {
    component: RequireAuth(Deposits),
    exact: true,
    path: '/Deposits',
  },
  {
    component: RequireAuth(Settings),
    exact: true,
    path: ['/settings', '/settings/:slug'],
  },
  {
    component: RequireAuth(Orders),
    exact: true,
    path: '/orders',
    casl: 'Orders',
  },
  {
    component: RequireAuth(SalaryCardOrder),
    exact: true,
    path: '/orders/salary-card',
    casl: 'SalaryCard',
  },
  {
    component: RequireAuth(businessCardOrder),
    exact: true,
    path: '/orders/business-card',
    casl: 'BusinessCardOrder',
  },
  {
    component: RequireAuth(CreateSalaryCardOrder),
    exact: true,
    path: '/orders/salary-card/create',
    casl: 'SalaryCard',
  },
    {
    component: RequireAuth(CreateBusinessCardOrder),
    exact: true,
    path: '/orders/business-card/create',
    casl: 'BusinessCardOrder',
  },
  {
    component: RequireAuth(UpdateSalaryCardOrder),
    exact: true,
    path: '/orders/salary-card/update/:id',
    casl: 'SalaryCard',
  },
  
  {
    component: RequireAuth(UpdateBusinessCardOrder),
    exact: true,
    path: '/orders/business-card/update/:id',
    casl: 'BusinessCardOrder',
  },
  {
    component: RequireAuth(Acquiring),
    exact: true,
    path: '/acquiring',
  },
  {
    component: RequireAuth(PostReport),
    exact: true,
    path: '/acquiring/posreport',
    casl: 'Acquiring',
  }
]

export const settingsMenus = [
  {
    label: i18next.t("settings.userProfile"),
    path: '/settings'
  },
  {
    label: i18next.t("login.changePasswordTitle"),
    path: '/settings/change_password'
  },
  // {
  //   label : 'Hesablar',
  //   path : '/settings/accounts'
  // },
  // {
  //   label : 'Vidjetlər',
  //   path : '/settings/widgets'
  // },
  // {
  //   label : 'Şirkətin profili',
  //   path : '/settings/company_profile'
  // }
  // {
  //   label : i18next.t("home.accounts"),
  //   path : '/settings/accounts'
  // },
  // {
  //   label : i18next.t("settings.widgets"),
  //   path : '/settings/widgets'
  // },
  // {
  //   label : i18next.t("settings.companyProfile"),
  //   path : '/settings/company_profile'
  // }
]

// i18next.on('languageChanged', (language) => {
//   settingsMenus[1]["label"] = i18next.t("login.changePasswordTitle")
// })

export const trnTypes = {
  OWN_ACCOUNT: {
    title: i18next.t("transfers.internalToOwnAccount"),
    url: '/new_transfer/inside_bank/own_account',
    shortName: 'IM'
  },
  INTERNAL: {
    title: i18next.t("transfers.internalToOtherAccount"),
    url: '/new_transfer/inside_bank/other_account',
    shortName: 'IT'
  },
  EXCHANGE: {
    title: i18next.t("home.currencyExchange"),
    url: '/new_transfer/currency_exchange',
    shortName: 'FX'
  },
  AZIPS: {
    title: 'AZİPS',
    url: '/new_transfer/domestic/azips',
    shortName: 'AZ'
  },
  XOHKS: {
    title: 'XÖHKS',
    url: '/new_transfer/domestic/hoks',
    shortName: 'XO'
  },
  DXA: {
    title: i18next.t("home.budgetSTA"),
    url: '/new_transfer/domestic/dxa',
    shortName: 'XT'
  },
  EDV: {
    title: i18next.t("home.budgetVAT"),
    url: '/new_transfer/domestic/edv',
    shortName: 'XV'
  },
  IPS_OTH: {
    title: 'AniPay - qeyri büdcə',
    url: '/new_transfer/anipay/qbudce',
    shortName: 'PI'
  },
  IPS_BDG: {
    title: 'AniPay - DXA',
    url: '/new_transfer/anipay/dxa',
    shortName: 'PT'
  },
  IPS_VAT: {
    title: 'AniPay - ƏDV',
    url: '/new_transfer/anipay/edv',
    shortName: 'PV'
  },
  SWIFT: {
    title: i18next.t("home.foreignCurrencyTransfer"),
    url: '/new_transfer/foreign_currency/money_transfer',
    shortName: 'FP'
  },
  SWIFT_RUB: {
    title: 'RUB',
    url: '/new_transfer/foreign_currency/rub',
    shortName: 'RP'
  }
}
// const Translate = (value:any) =>{
//   const {t} =useTranslation()
//   console.log(t(value))
// }
// export const leftMenus = [
//   {
//     title:Translate("home.main"),
//     path: '/',
//     icon: HomePageIco,
//     subs: [],
//     permissionKey: 'ALL'
//   },
//   {
//     title: i18next.t("home.transfers"),
//     path: '/transfers/ALL',
//     icon: TransfersIco,
//     subs: [],
//     permissionKeys: ['AZIPS', 'SWIFT', 'XOHKS', 'BATCH_PAYMENT', 'EXCHANGE', 'INTERNAL', 'OWN_ACCOUNT', 'DXA', 'IPS_OTH', 'IPS_BDG', 'IPS_VAT', 'EDV', 'SWIFT_RUB', 'TEMPLATE', 'SALARY_TOTAL']
//   },
//   {
//     title: i18next.t("home.newTransfer"),
//     path: '/new_transfer/',
//     icon: NewTransferIco,
//     permissionKeys: ['OWN_ACCOUNT', 'INTERNAL', 'EXCHANGE', 'AZIPS', 'XOHKS', 'DXA', 'EDV', 'SWIFT', 'SWIFT_RUB', 'TEMPLATE'],
//     subs: [
//       {
//         title: i18next.t("home.internal"),
//         path: '/new_transfer/inside_bank',
//         permissionKeys: ['OWN_ACCOUNT', 'INTERNAL'],
//         subs: [
//           {
//             title: i18next.t("newTransfer.ownAccount"),
//             path: '/new_transfer/inside_bank/own_account',
//             permissionKey: 'OWN_ACCOUNT',
//           },
//           {
//             title: i18next.t("newTransfer.toOtherAccount"),
//             path: '/new_transfer/inside_bank/other_account',
//             permissionKey: 'INTERNAL',
//           }
//         ]
//       },
//       {
//         title: i18next.t("home.currencyExchange"),
//         path: '/new_transfer/currency_exchange',
//         subs: [],
//         permissionKey: 'EXCHANGE',
//       },
//       {
//         title: i18next.t("home.domesticAZN"),
//         path: '/new_transfer/domestic',
//         permissionKeys: ['AZIPS', 'XOHKS', 'DXA', 'EDV'],
//         subs: [
//           {
//             title: 'AZİPS',
//             path: '/new_transfer/domestic/azips',
//             permissionKey: 'AZIPS',
//           },
//           {
//             title: 'XÖHKS',
//             path: '/new_transfer/domestic/hoks',
//             permissionKey: 'XOHKS',
//           },
//           {
//             title: i18next.t("home.budgetSTA"),
//             path: '/new_transfer/domestic/dxa',
//             permissionKey: 'DXA',
//           },
//           {
//             title: i18next.t("home.budgetVAT"),
//             path: '/new_transfer/domestic/edv',
//             permissionKey: 'EDV',
//           }
//         ]
//       },
//       {
//         title: i18next.t("home.foreignCurrency"),
//         path: '/new_transfer/foreign_currency',
//         permissionKeys: ['SWIFT', 'SWIFT_RUB'],
//         subs: [
//           {
//             title: i18next.t("home.foreignCurrencyTransfer"),
//             path: '/new_transfer/foreign_currency/money_transfer',
//             permissionKey: 'SWIFT',
//           },
//           {
//             title: 'RUB',
//             path: '/new_transfer/foreign_currency/rub',
//             permissionKey: 'SWIFT_RUB',
//           }
//         ]
//       },
//       {
//         title: i18next.t("home.templates"),
//         path: '/new_transfer/templates',
//         subs: [],
//         permissionKey: 'TEMPLATE',
//       }
//     ]
//   },
//   {
//     title: i18next.t("home.accounts"),
//     path: '/accounts/',
//     icon: AccountIco,
//     permissionKeys: ['ALL'],
//     subs: [
//       {
//         title: i18next.t("home.accounts"),
//         path: '/accounts/accounts',
//         permissionKey: 'CARILIST',
//         subs: []
//       },
//       {
//         title: i18next.t("home.accountStatement"),
//         path: '/accounts/account_statement',
//         permissionKey: 'ALL',
//         subs: []
//       }
//     ]
//   },
//   {
//     title: i18next.t("home.businessCards"),
//     path: '/business_cards/',
//     icon: BusinessCardIco,
//     permissionKeys: ['CARDLIST'],
//     subs: [
//       {
//         title: i18next.t("home.businessCards"),
//         path: '/business_cards/cards',
//         permissionKey: 'CARDLIST',
//         subs: []
//       },
//       // {
//       //     title : i18next.t("businessCards.cardAccountStatement"),
//       //     path : '/business_cards/card_account_statement',
//       //     permissionKey : 'ALL',
//       //     subs : []
//       // },{
//       //   title : i18next.t("businessCards.cardStatement"),
//       //   path : '/business_cards/card_accountpan_statement',
//       //   permissionKey : 'ALL',
//       //   subs : []
//       // }
//     ]
//   },
//   {
//     title: i18next.t("home.salary"),
//     path: '/salary/',
//     icon: SalaryIco,
//     permissionKeys: ['ALL'],
//     subs: [
//       {
//         title: i18next.t("home.transfer"),
//         path: '/salary/transfer',
//         permissionKey: 'SALARY_TOTAL',
//         subs: []
//       },
//       {
//         title: i18next.t("home.listOfEmployees"),
//         path: '/salary/list',
//         permissionKey: 'SALARY_EMP',
//         subs: []
//       },
//       {
//         title: i18next.t("home.statement"),
//         path: '/salary/print',
//         permissionKey: 'ALL',
//         subs: []
//       }
//     ]
//   },
//   {
//     title: i18next.t("home.loans"),
//     path: '/credits',
//     icon: CreditIco,
//     permissionKey: 'CREDITLIST',
//     subs: []
//   },
//   {
//     title: i18next.t("home.deposits"),
//     path: '/deposits',
//     icon: DepositsIco,
//     permissionKey: 'DEPOSITLIST',
//     subs: []
//   },
// ]

const Routes: React.FC<any> = ({ leftMenuStatus }) => {
  const responsiveWidth = useResponsiveWidth();

  const location = useLocation();
  const history = useHistory();
  const pathname = location.pathname;
  const isLoginPage = pathname.includes('login')
  const layoutCss = isLoginPage ? {} : { marginTop: 20, marginRight: 8, paddingRight: responsiveWidth <= 650 ? 5 : 20, paddingLeft: (responsiveWidth <= 650) ? 10 : (responsiveWidth <= 650) ? 69 : (leftMenuStatus) ? (pathname.includes('settings')) ? 96 : (responsiveWidth <= 1720) ? 69 : 126 : 270 };
  const layoutClass = isLoginPage ? '' : 'layout_scroll';
  const layoutId = isLoginPage ? '' : 'layout_scroll';
  const contentCss = (isLoginPage || responsiveWidth >= 650) ? { width: '100%' } : { paddingLeft: 0,  width: '100%' }
  const scrollClass = isLoginPage ? '' : 'scroll_y';
  const timeout = 900000;
  const [remaining, setRemaining] = useState(timeout);
  const [isIdle, setIsIdle] = useState(false);

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => setIsIdle(true);

  const { getRemainingTime } = useIdleTimer({
    timeout,
    throttle: 1000,
    onActive: handleOnActive,
    onIdle: handleOnIdle
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 1000);

    return () => {
      clearInterval(interval)
    }
  });

  useEffect(() => {
    if (isIdle) {
      history.push('/login')
    }
  }, [isIdle]);

  const onScroll = () => {
    const ant_select = document.querySelector('.ant-select');

    var clickEvent = new Event("click");
    ant_select?.dispatchEvent(clickEvent);
  }


  // @ts-ignore
  return (
    <>
      {/*<Suspense fallback={<div>Loading..</div>}>*/}

      <Layout>

        {/* Header */}
        {
          !isLoginPage && <MainHeader />
        }

        <Layout className="site-layout">

          {/* left side */}
          {
            !isLoginPage && <LeftSide />
          }

          <Layout onScroll={onScroll} className={`site-layout ${scrollClass} ${layoutClass}`} id={layoutId} style={layoutCss} >

            <Content className={`site-layout-background `} style={contentCss} >

              {
                !isLoginPage && <ScrollToTop />
              }

              <Switch>
                {
                  routes.map((route: any) => (
                    <AppRoute {...route} key={route.path} />
                  ))
                }
                {isLoginPage ? <Route path="*"> <Redirect to="/login" /></Route>
                  :
                  <AppRoute path="*"> <Redirect to="/" /></AppRoute>
                }
           
              </Switch>

            </Content>

            {/* rightside */}
            {
              !isLoginPage && <RightSide />
            }

          </Layout>



        </Layout>


      </Layout>


      {/*</Suspense>*/}

    </>

  )
}

const mapDispatchToProps = { leftMenuToggle }

const mapStateToProps = (state: any) => ({
  leftMenuStatus: state.home.leftMenuStatus,
})

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
